import styled from "styled-components";

export const Background = styled.div`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 10px 0;
  background-color: #f0f0f0;
  box-sizing: border-box;
  -moz-box-sizing: border-box;

  .hidden {
    position: relative;
    z-index: 0;

    @media print {
      display: none;
    }
  }

  @page {
    size: A4 portrait;
    margin: 1cm 1cm 2cm;
  }

  @page :first {
    margin-top: 0;
  }

  @media print {
    width: 210mm;
    height: 297mm;
  }
`;

export const Page = styled.div`
  width: 210mm;
  min-height: 297mm;
  padding: 5mm;
  margin: 10mm auto;
  background: white;

  @media print {
    margin: 0;
    border: none;
    border-radius: 0;
    box-shadow: none;
    page-break-after: always;
  }
`;

export const Subpage = styled.div`
  /* Allow content to flow naturally for automatic page breaks */
  height: auto;
`;

export const Images = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  img {
    &:nth-child(1) {
      height: 60px;
    }
    &:nth-child(2) {
      height: 40px;
    }
  }
`;

export const Breaker = styled.div`
  width: 100%;
  height: fit-content;
`;

export const Content = styled.div`
  width: 100%;
  p {
    font-size: 12px;
    position: relative;
  }
  span {
    text-align: center;
  }
`;

export const Title = styled.h1`
  font-size: 12px;
  text-align: center;
  padding: 20px 0;
`;

export const Table = styled.table`
  font-size: 10px;
  width: 100%;
  text-align: center;
  margin: 20px 0;
  border-collapse: collapse;
  position: relative;

  thead {
    display: table-header-group; /* repeat header on each page */
  }
  tfoot {
    display: table-footer-group;
  }
  tr {
    page-break-inside: avoid; /* prevent row splitting */
  }

  th,
  td {
    border: 0.1px solid #000;
    padding: 5px;
    text-transform: uppercase;
  }
`;

export const Assinaturas = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  position: relative;
  z-index: 5;

  div {
    font-size: 12px;
  }
`;
